import { removeToken } from "../setup/api";

export default {
  logout(context) {
    return new Promise(resolve => {
      removeToken();
      context.commit("user/reset");
      resolve();
    });
  }
};
